import React from "react";
import PropTypes from "prop-types";
import Footer from "../Footer";

import { GlobalStyle } from "../styles/global";
import GlobalFonts from "../styles/globalFonts";

const Layout = ({ children }) => {
  return (
    <>
      <GlobalStyle />
      <GlobalFonts />
      <main>{children}</main>
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
